import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';

import { ThumbsComponent } from '../../thumbs.shared.component';

@Component({
    selector: 'shared-thumb-for-promotion-item',
    templateUrl: './thumb-for-promotion-item.shared.component.html',
    styleUrls: ['./thumb-for-promotion-item.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThumbForPromotionItemComponent extends ThumbsComponent implements OnInit {
    @Input() public layout: 'row' | 'column' = 'row';
    @Input() public width: number = 475;
    @Input() public height: number = 270;

    constructor() {
        super();
    }

    ngOnInit(): void {
        if (this.layout === 'row') {
            this.width = 230;
            this.height = 200;
        }
    }
}
